export enum EnergyType {
  Electric = 'Electric',
  NaturalGas = 'Natural Gas',
  Diesel = 'Diesel',
}
